import { Modal, Text, Icon, Button, Heading } from '@afterpaytouch/core'
import React, { FunctionComponent, useState } from 'react'
import styles from './style.module.css'

export interface InfoModalProps {
  title: string
  description: string
  countries: string[]
}

export const InfoModal: FunctionComponent<InfoModalProps> = (info) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <div className={styles.infoModal}>
      <div className={styles.infoButton}>
        <Button kind='Tertiary' aria-label='info' onClick={() => setShowModal(true)} size='Small'>
          <Icon.Info size='Small' />
        </Button>
      </div>
      <Modal show={showModal} onClose={() => setShowModal(false)} testNameSpace='info-modal'>
        <Modal.Header>
          <div className={styles.infoModalHeader}>
            <Heading size='XL'>{info.title}</Heading>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Text>{info.description}</Text>
          <ul className={styles.infoModalList}>
            {info.countries.map((country) => (
              <li key={country}>
                <Text>{country}</Text>
              </li>
            ))}
          </ul>
        </Modal.Content>
      </Modal>
    </div>
  )
}
